var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7203 0.2417C18.5493 -0.248386 20.4294 0.83704 20.9194 2.66607L22.9686 10.3134C23.4586 12.1425 22.3732 14.0225 20.5442 14.5126C18.7152 15.0026 16.8351 13.9172 16.3451 12.0882L14.296 4.44082C13.8059 2.6118 14.8913 0.731786 16.7203 0.2417ZM0.33252 16.6641C-0.157566 18.4932 0.92786 20.3732 2.75689 20.8633L10.4043 22.9124C12.2333 23.4024 14.1133 22.317 14.6034 20.488C15.0935 18.659 14.008 16.779 12.179 16.2889L4.53165 14.2398C2.70262 13.7497 0.822606 14.8351 0.33252 16.6641ZM20.4449 25.6477C19.2523 22.0732 22.6536 18.6719 26.2281 19.8645L58.7725 30.7222C62.9781 32.1253 62.9247 38.0927 58.6946 39.4203L49.4349 42.3264L61.7789 54.6704C63.5642 56.4556 63.5642 59.3501 61.7789 61.1354C59.9937 62.9206 57.0992 62.9206 55.3139 61.1354L42.9369 48.7584L40.0007 58.1142C38.6731 62.3443 32.7057 62.3977 31.3026 58.1921L20.4449 25.6477ZM9.46064 39.5225C8.1217 40.8614 5.95085 40.8614 4.61191 39.5225C3.27297 38.1835 3.27297 36.0127 4.61191 34.6737L10.2102 29.0755C11.5491 27.7365 13.72 27.7365 15.0589 29.0755C16.3978 30.4144 16.3978 32.5853 15.0589 33.9242L9.46064 39.5225ZM38.9785 9.39076C40.3174 8.05182 40.3174 5.88097 38.9785 4.54203C37.6396 3.20309 35.4687 3.20309 34.1298 4.54203L28.5315 10.1403C27.1926 11.4792 27.1926 13.6501 28.5315 14.989C29.8704 16.328 32.0413 16.328 33.3802 14.989L38.9785 9.39076Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.52734a99563d23e6d12a8dc10cacc00c.svg";
export { ForwardRef as ReactComponent };